// @generated by tools/docgen — do not edit.
// Source: docs/examples/task_board.md

import React from 'react';
import { TaskBoardDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function TaskBoardPage() {
  return (
    <ExampleLayout title="Task board" demo={<TaskBoardDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          Adding routing='project_id' to a queryset list makes it fully live: a task created under a watched project, or moved into it, appears the moment the write commits -- no rebind, unlike <a href={`${process.env.PUBLIC_URL || ''}/examples/static_queryset`} className="text-primary-700 hover:underline">Static queryset</a>, where a new row waits for a rebind. Moving a task out delivers the removal just as immediately. Routing also decides what the server sends at all: a connection only receives events for the projects it watches, so data for other projects never reaches the client -- while the queryset's other conditions (like this example's status='open') are applied client-side, on rows already delivered. To deliberately send a list's events to every connection, declare routing=BroadcastRouter().
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-task-board-backend">
        <ExampleSectionHeading id="examples-task-board-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="task_board/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-task-board-models">
        <ExampleSectionHeading id="examples-task-board-models">
          Models
        </ExampleSectionHeading>
        <SourceFile path="task_board/models.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-task-board-serializers">
        <ExampleSectionHeading id="examples-task-board-serializers">
          Serializers
        </ExampleSectionHeading>
        <SourceFile path="task_board/serializers.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-task-board-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-task-board-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="task_board/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default TaskBoardPage;
